/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon20Light = forwardRef('TimeClockStopwatchIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 5.5a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 1v2.016a7.5 7.5 0 1 0 6.145 2.546l1.459-1.458a.5.5 0 0 0-.708-.708l-1.458 1.459A7.469 7.469 0 0 0 10 3.016V1h2a.5.5 0 0 0 0-1H7a.5.5 0 0 0 0 1h2Zm-6 9.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z" })));
});
